import { colors2, UI_TAG } from "oolib";
import styled from "styled-components";

export const StyledSummaryContainer = styled.div`
  padding: 1.4rem 2rem;
  background: #fff;
  border-radius: 0.6rem;
  display: flex;
  flex-direction: column;
  gap: .8rem;
  border-bottom: 1px solid ${colors2.grey10};
`;

export const StyledSummaryHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const StyledSummaryHeaderLeft = styled.div`
  display: flex;
  gap: 0.8rem;
`;

export const StyledAISummaryTag = styled(UI_TAG)`
  background: #7C3AED;
  color: white;
  padding: 0.2rem 0.6rem;
  border-radius: 0.4rem;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const StyledCollapseToggle = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
`;

export const StyledCollapsibleContent = styled.div`
  height: ${({ $height }) => typeof $height === 'number' ? `${$height}px` : $height};
  overflow: hidden;
  transition: height 0.3s cubic-bezier(0.25, 1, 0.4, 1);
`;

/* Short ↔ detailed summary toggle — same pattern as PublishedPageV3's
   SummaryToggleLink (bare underlined button). */
export const StyledSummaryToggleLink = styled.button`
  appearance: none;
  background: none;
  border: none;
  padding: 0;
  margin-top: 0.8rem;
  color: ${colors2.grey80};
  text-decoration: underline;
  cursor: pointer;
  & > * {
    margin: 0;
  }
  &:hover {
    color: ${colors2.grey100};
  }
`;
